module.exports = __webpack_public_path__ + "static/media/cswap-icon.2929354b.svg";